import React from 'react';
import COMPANY_INFO from '../data/companyInfo';

// The two signature lines at the bottom of a printed document: someone authorized at Caribbean Gas, and the client.
// Shared by the factura, cotización and conduce print views. The company's line carries the authorized signature and the
// company seal (public/firma-autorizada.png, made by backend/scripts/make-signature-stamp.py). The PDFs CG Connect
// downloads (backend/services/documentPdf.js) use the same image at the same proportions — change both together.
// `receiverLabel` replaces "Recibido por el cliente" where the other party isn't a client (a compromiso's creditor).
const SignatureLines = ({ clientName, receiverLabel = 'Recibido por el cliente' }) => (
  <div className="signature-block">
    <div className="signature-box">
      <div className="signature-space">
        <img src="/firma-autorizada.png" alt="Firma autorizada y sello de Caribbean Gas Company" className="signature-stamp" />
      </div>
      <div className="signature-line" />
      <div className="signature-label">Firma autorizada</div>
      <div className="signature-sub">{COMPANY_INFO.name}</div>
    </div>
    <div className="signature-box">
      <div className="signature-space" />
      <div className="signature-line" />
      <div className="signature-label">{receiverLabel}</div>
      <div className="signature-sub">{clientName ? `${clientName} · ` : ''}Nombre, cédula y firma</div>
    </div>
  </div>
);

export default SignatureLines;
